import { memo, useCallback, useMemo, useRef, useState } from 'react';
import { FiFile, FiUpload } from 'react-icons/fi';
import { uploadTutorCertificate } from '../../../store/profile/profileActions';
import { useDispatch } from 'react-redux';
import { Spinner } from '../../animation/spinner';
import toast from 'react-hot-toast';

const CertificateFileInput = ({ name, register, acceptType = '', errors, required, setValue,getValues }) => {
    const hiddenFileInput = useRef(null);
    const dispatch = useDispatch();
    const [localError, setLocalError] = useState(null);

    const [fileName, setFileName] = useState(null)
    const handleClick = () => {
        hiddenFileInput.current.click();
    };

    const [isUploading, setIsUploading] = useState(false);

    const Preview = memo(() => {
        if (fileName && fileName.trim().length > 0) {
            return (
                <>
                    <FiFile size={25} />
                    <p className='px-2 truncate w-[180px]'>{fileName}</p>
                </>
            )
        } else {
            return (
                <>
                    <FiUpload size={25} />
                    <p className='px-2'>Upload a file</p>
                </>
            )
        }
    }, [fileName])

    const handleSelectFile = useCallback(async (e) => {
        const file = e.target.files?.[0];
        setLocalError(null);

        if (!file) return;

        if (file.size / 1024 > 5000) {
            setLocalError("File size must be less than 5MB");
            return;
        }

        if(!acceptType.includes(file.type)){
            toast.error("File Type Not Supported");
            return;
        }

        setIsUploading(true);
        setFileName(file.name)
        setValue(name, [file])
        dispatch(uploadTutorCertificate({ certificate: file }))
            .unwrap()
            .then((v) => {
                if(v.error){
                    toast.error("File Type Not Supported");
                    setFileName(null);
                    setIsUploading(false);
                    return;
                }
                setFileName(file.name)
                setValue(name, v.id);
                setIsUploading(false);
            })
            .catch((error) => {
                setFileName(null);
                toast.error("File Type Not Supported");
                setIsUploading(false);
            });
    }, [dispatch]);
    
    return (
        <div className="h-full w-full flex items-center justify-center cursor-pointer">
            <div className={`relative w-full h-full flex flex-col items-center justify-center  ${isUploading ? "opacity-50" : ""}`} onClick={() => handleClick()}>
               {isUploading ? <div className='absolute z-50 w-full top-[38px]'>
                    <Spinner className="" />
                </div>: null}
                <Preview />
            </div>
            <input
                id={name}
                name={name}
                style={{ display: "None" }}
                type="file"
                accept={acceptType}
                onChange={handleSelectFile}
                ref={hiddenFileInput} />

            <input type='hidden' {...register(name)} />
            

        </div>
    )
};
export { CertificateFileInput };